import { supabase } from '@/lib/supabaseClient';
import { withRetry } from '@/utils/retry';

export interface UserProfile {
  id: string;
  email: string | null;
  display_name: string;
  avatar_url: string | null;
  source: 'auth' | 'imported';
}

/**
 * Get all user profiles (for resolving user_ids to display names)
 */
export async function getUserProfiles(): Promise<UserProfile[]> {
  const { data, error } = await withRetry(() =>
    supabase
      .from('profiles')
      .select('id, email, display_name, avatar_url, source')
      .order('display_name')
  );

  if (error) {
    console.warn('Error loading user profiles:', error.message);
    return [];
  }

  return data || [];
}
